import {
    Children,
    FC,
    useState,
    useEffect,
} from 'react';

import IRenderDelayerProperties from './types';

// @ts-ignore
export const RenderDelayer: FC<IRenderDelayerProperties> = ({
    delay, index, grow, children,
}) => {
    const [shouldDisplayChildren, setShouldDisplayChildren] = useState<boolean>(!delay);

    useEffect(() => {
        const displayChildren = () => { setShouldDisplayChildren(true); };
        const displayTimeout = !!delay && setTimeout(displayChildren, index ? (index * 100) + delay : delay);

        return () => (displayTimeout ? clearTimeout(displayTimeout) : undefined);
    }, [delay, index, setShouldDisplayChildren]);

    return Children.map(children, (child) => ({
        // @ts-ignore
        ...child,
        props: {
            ...child.props,
            style: {
                ...child.props.style,
                ...(grow && { transform: shouldDisplayChildren ? 'scale(1)' : 'scale(.7)' }),
                opacity    : shouldDisplayChildren ? 1 : 0,
                transition : 'all .5s ease',
            },
        },
    }));
};

RenderDelayer.defaultProps = {
    delay: 0,
};

export default RenderDelayer;
